/**
 * Import Dependency
 */
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

/**
 * Import Component
 */
import Grid from '../../components/Grid'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {

  }
}
const mapDispatchToProps = (dispatch) => {
  return {

  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Grid))



// WEBPACK FOOTER //
// ./src/containers/components/Grid.js